import React from "react";
import { useParams, useHistory } from "react-router-dom";
import theme from "theme";
import { Theme, Image, Box, Section, Text } from "@quarkly/widgets";
import { GlobalQuarklyPageStyles } from "global-page-styles";
import { RawHtml, Override } from "@quarkly/components";

import * as Components from "components";
import articles from "./_articles_data";

export default () => {
  const { articleId } = useParams();
  const history = useHistory();
  const article = articles[articleId];

  if (!article) {
    history.push("/404");
    return null;
  }

  function generateArticleContent(article) {
    const { article_pattern, additionalParagraphs, additionalImages } = article;
    let paragraphIndex = 0;
    let imageIndex = 0;

    return article_pattern.map((type, index) => {
      if (type === "paragraph") {
        return (
          <Text
            key={index}
            color="--light"
            font="--base"
            text-align="left"
            lg-font='normal 400 16px/1.5 "Varta", sans-serif'
            md-margin="0px 16px 16px 0px"
            margin="0px 12px 12px 0px"
          >
            {additionalParagraphs[paragraphIndex++]}
          </Text>
        );
      } else if (type === "image") {
        return (
          <Image
            key={index}
            src={additionalImages[imageIndex++]}
            width="100%"
            // height="100%"
            max-height="700px"
            object-fit="cover"
            lg-min-height="300px"
            md-max-height="277px"
            md-min-height="16px"
            overflow="hidden"
            srcSet={`${additionalImages[imageIndex - 1]} 500w, ${
              additionalImages[imageIndex - 1]
            } 800w, ${additionalImages[imageIndex - 1]} 1080w, ${
              additionalImages[imageIndex - 1]
            } 1600w, ${additionalImages[imageIndex - 1]} 2000w, ${
              additionalImages[imageIndex - 1]
            } 2600w, ${additionalImages[imageIndex - 1]} 3200w`}
            sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,100vw"
          />
        );
      }
      return null;
    });
  }

  return (
    <Theme theme={theme}>
      <GlobalQuarklyPageStyles pageUrl={"index"} />
      <Components.CombinedHelmetNHeader />
      <Section
        padding="60px 0 60px 0"
        md-padding="30px 0 30px 0"
        quarkly-title="Section_PP_Content"
      >
        <Override
          slot="SectionContent"
          flex-direction="column"
          md-flex-wrap="wrap"
        />
        <Box
          empty-min-width="64px"
          padding="0px 0px 0px 0px"
          md-padding="0px 0px 0px 0px"
          md-width="100%"
          width="100%"
          lg-padding="0px 28px 0px 0px"
          empty-min-height="64px"
          empty-border-width="1px"
          empty-border-style="solid"
          empty-border-color="LightGray"
        >
          <Text
            font="--headline2"
            lg-font="normal 500 32px/1.2 --fontFamily-googleAlegreyaSans, sans-serif"
            md-font="normal 500 28px/1.2 --fontFamily-googleAlegreyaSans, sans-serif"
            margin="0px 0px 12px 0px"
            color="--green"
          >
            {article.title}
          </Text>

          <Text
            color="--light"
            font="--base"
            text-align="left"
            lg-font='normal 400 16px/1.5 "Varta", sans-serif'
            md-margin="0px 0px 16px 0px"
            margin="0px 0px 12px 0px"
          >
            {article.shortDescription}
          </Text>

          <Image
            src={article.image}
            width="100%"
            // height="100%"
            max-height="700px"
            object-fit="cover"
            lg-min-height="300px"
            md-max-height="277px"
            md-min-height="16px"
            overflow="hidden"
            srcSet={`${article.image} 500w, ${article.image} 800w, ${article.image} 1080w, ${article.image} 1600w, ${article.image} 2000w, ${article.image} 2600w, ${article.image} 3200w`}
            sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,100vw"
          />

          {generateArticleContent(article)}
        </Box>
      </Section>

      <Components.CustomFooter />
      <RawHtml>
        <style place={"endOfHead"} rawKey={"6166a2b829a0a1001e6ca5fb"}>
          {
            ":root {\n  box-sizing: border-box;\n}\n\n* {\n  box-sizing: inherit;\n}"
          }
        </style>
      </RawHtml>
    </Theme>
  );
};
